import { API_GET_ONE_DEMO_SOLUTION_SUCCESS, CREATE_DEMO_FAVORITE, DELETE_DEMO_FAVORITE, } from '../actions/DemoSolutionActions';
const INITIAL_STATE = {
    isFavorite: false,
    item: null,
    recommendations: [],
};
// eslint-disable-next-line default-param-last
export default (state = Object.assign({}, INITIAL_STATE), { payload, type }) => {
    switch (type) {
        // 取得開始
        case API_GET_ONE_DEMO_SOLUTION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { item: Object.assign({}, payload.solution), recommendations: [...payload.recommendations] });
        }
        // お気に入り処理
        case CREATE_DEMO_FAVORITE: {
            return Object.assign(Object.assign({}, state), { hasFavorite: true });
        }
        case DELETE_DEMO_FAVORITE: {
            return Object.assign(Object.assign({}, state), { hasFavorite: false });
        }
        default: {
            return state;
        }
    }
};
